import ColorPickerIcon from '@/components/icons/ColorPickerIcon';
import { FC, useRef } from 'react';

type Props = {
	value: string;
	onChange: (e: string) => void;
};

const EColorPicker: FC<Props> = ({ value, onChange }) => {
	const colorInputRef = useRef<HTMLInputElement | null>(null);

	const handleSelectColor = () => {
		colorInputRef.current?.click();
	};

	return (
		<div>
			<div
				className='absolute z-10 top-1/2 right-3.5 transform -translate-y-1/2 text-xs text-popover-700 cursor-pointer'
				onClick={handleSelectColor}>
				<ColorPickerIcon />
			</div>
			<input
				ref={colorInputRef}
				type='color'
				className='size-0 absolute top-75 right-36'
				value={value ?? ''}
				onChange={(e) => onChange(e.target.value)}
			/>
		</div>
	);
};

export default EColorPicker;
